export default __webpack_public_path__ + "static/media/covidVaccine.262d7b08.png";